import React from 'react';
import { menuAfterIcon, MenuAfterShowNew } from '../../utils/formatters';
import ReportPage from './components/ReportPage';
import ReportTemplatePage from './components/ReportTemplatePage';
import ReportExportPage from './components/ReportExportPage';

const routes = [
  {
    path: '/report/list',
    name: 'menu.report',
    icon: 'report',
    customIcon: true,
    loginRequired: true,
    component: ReportPage,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/report/template',
        name: 'menu.report.template',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: ReportTemplatePage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/report/list',
        name: 'menu.report.list',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        component: ReportPage,
        afterContent: <MenuAfterShowNew link="/report/list?new=1" />,
        weight: 2,
        permission: [],
        children: [],
      },
      // {
      //   path: '/report/export',
      //   name: 'menu.report.export',
      //   icon: 'application',
      //   customIcon: true,
      //   loginRequired: true,
      //   component: ReportExportPage,
      //   weight: 2,
      //   permission: [],
      //   children: [],
      // },
    ],
  },
];

export default routes;
